export default "__VITE_ASSET__J_VmPgk6__"